// TODO Kanske finns något bättre sätt att få tag i query params med React router?
export function getQueryParam(paramName) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(paramName);
}
